import React, {Component} from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from "redux";
import {Form, Control} from "react-redux-form";
import Hero from "../components/hero";
import { activate } from '../reducers/auth'
import store from "../store";
import { push } from 'connected-react-router'

class Activate extends Component {
	componentWillMount() {
		window.scrollTo(0,0);

		if(!this.props.auth.token){
			store.dispatch(push('/'));
		}
	}

	render() {
		return (
			<main className="">
				<Hero {...this.props} />

				<section className="content bg-color_gradient paddingLeft-150 shadow-top">
					<div className="row">

						<div className="col-12">
							<h3 className="blue-text bold">Please Activate Your Account</h3>
						</div>

						<div className="col-12 col-lg-6">
							<div className="text">
								<p>We've sent an email to the address you used to register containing<br/> a 5-digit code. Please enter it below to proceed.</p>

								{this.props.auth.error && <p className="error">{this.props.auth.error}</p>}

								<div className="form-style">
									<Form model={'auth'} onSubmit={this.props.activate}>
										<div className="row">
											<div className="col-lg-12">
												<div className="position-relative input-effect">
													<Control.text model={'.user.ActivationKey'} className={!!this.props.auth.user.ActivationKey ? 'effect has-content' : 'effect'} maxLength={6} type="text" />
													<label>Activation key</label>
												</div>
											</div>

											<div className="col-lg-12">
												<input type="submit" className="submit bold btn-hover" value="Start the Challenge" />
											</div>
										</div>
									</Form>
								</div>
							</div>
						</div>
					</div>
				</section>
			</main>
		);
	}
}

function mapStateToProps(state) {
	return {auth: state.auth};
}

const mapDispatchToProps = dispatch => bindActionCreators({
	activate
}, dispatch)

export default connect(
	mapStateToProps,
	mapDispatchToProps
)(Activate);